import { render, staticRenderFns } from "./CustomerImage.vue?vue&type=template&id=017f575b&"
import script from "./CustomerImage.vue?vue&type=script&lang=js&"
export * from "./CustomerImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports